import FileRenderer from "./FileRenderer";
export default FileRenderer;
